module.exports = __webpack_public_path__ + "img/ballon-coiffure.984390ac.png";